import { LOAD_NODES } from "../actions/ActionTypes";

/* Load all the nodes into redux store. */
export default function NodeReducer(
  state = [],
  action: Record<string, unknown>
): unknown {
  switch (action.type) {
    case LOAD_NODES:
      return action.payload;
    default:
      return state;
  }
}
